var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "a",
    { staticClass: "search-preview", attrs: { href: _vm.props.item.url } },
    [
      _vm._m(0),
      _c("span", { staticClass: "search-preview__info" }, [
        _c("span", {
          staticClass: "search-preview__text",
          domProps: {
            innerHTML: _vm._s(
              _vm.props.fn(
                _vm.props.item.question,
                _vm.props.item.question,
                _vm.props.localsearch
              )
            )
          }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function(_h, _vm) {
    var _c = _vm._c
    return _c(
      "span",
      {
        staticClass: "search-preview__img-wrap search-preview__img-wrap--mini"
      },
      [
        _c("img", {
          staticClass: "search-preview__img",
          attrs: { src: "/static/images/page_preview.svg" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85394228", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85394228","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/search/parts/faq.vue
// module id = 223
// module chunks = 4